import { useMediaQuery, useTheme } from '@mui/material';

export type ContactsVariant = 'card' | 'row' | 'compact';

export type ContactsDisplayMode = 'list' | 'grid';

export const resolveContactsVariant = (isXs: boolean, isSm: boolean): ContactsVariant => {
  if (isXs) return 'card';
  if (isSm) return 'row';
  return 'compact';
};

// The list table hides columns below sm, so phones always get cards.
export const resolveDisplayMode = (
  variant: ContactsVariant,
  preferred: ContactsDisplayMode
): ContactsDisplayMode => (variant === 'card' ? 'grid' : preferred);

export const resolveDialogFullScreen = (variant: ContactsVariant): boolean => variant === 'card';

// card: phones (xs). row: tablets portrait (sm). compact: md+ workspace.
const useContactsVariant = (): ContactsVariant => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));

  return resolveContactsVariant(isXs, isSm);
};

export default useContactsVariant;
